
<template>
  <div>
    <div>
      <span class="notice-title m-r-16">已按谈判名称自动生成</span>
      <el-button type="text" size="medium" @click="openNoticeTitles()">查看编辑</el-button>
    </div>
    <jczh-drawer
      class="drawer"
      :visible.sync="drawerVisible"
      title="编辑公告标题"
      size="800px"
      :el-attrs="{
        destroyOnClose: true,
        wrapperClosable: false
      }"
      @close="handleDrawerClose"
      @confirm="handleConfirm"
    >
      <template slot="content">
        <el-form ref="form" class="title-form" :model="formData">
          <el-table
            height="100%"
            border
            :data="formData.tableData"
            size="medium"
          >
            <el-table-column
              type="index"
              width="50"
              align="center"
              label="序号"
            />
            <el-table-column
              prop="orderName"
              label="关联的采购单"
              min-width="160"
              align="center"
            />
            <el-table-column label="公告标题" min-width="200" align="center">
              <template slot-scope="{ row, $index }">
                <el-form-item
                  :prop="'tableData.' + $index + '.title'"
                  :rules="formData.rules.title"
                >
                  <el-input
                    v-model="row.title"
                    type="textarea"
                    placeholder="请输入"
                    maxlength="100"
                    show-word-limit
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>
    </jczh-drawer>
  </div>
</template>
<script>

import { cloneDeep } from 'lodash'

export default {
  model: {
    event: 'change',
    prop: 'list'
  },

  props: {
    list: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      drawerVisible: false,
      formData: {
        tableData: [],
        rules: {
          title: { required: true, message: '请输入公告名称' }
        }
      }
    }
  },

  watch: {
    list: {
      handler: function(val) {
        this.formData.tableData = cloneDeep(val) || []
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    openNoticeTitles(data = {}) {
      this.drawerVisible = true
    },

    /**
     * 关闭弹窗
     */
    handleDrawerClose() {
      this.formData.tableData = cloneDeep(this.list) || []
      this.drawerVisible = false
    },

    /**
     * 保存
     */
    async handleConfirm() {
      const _valid = await this.$refs.form.validate()
      if (!_valid) return
      this.$emit('change', this.formData.tableData)
      this.drawerVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.title-form {
  margin: 24px 0;
  height: calc(100% - 48px);
}
.notice-title {
  color: $second-text-color;
}
</style>
